import { ApplicationConfig, LOCALE_ID, importProvidersFrom, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS, withXhr } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxLoadingModule } from "ngx-loading";
import { ToastrModule } from 'ngx-toastr';
import { provideServiceWorker } from '@angular/service-worker';
import { routes } from './app.routes';
import { JwtInterceptor } from './authentication/services/jwt.interceptor';
import { NgxFlickingModule } from '@egjs/ngx-flicking';
import { ApiService } from './services/api.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    ApiService,
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      NgxLoadingModule.forRoot({}),
      ToastrModule.forRoot(),
      NgxFlickingModule,
    ),
  ]
};
